// Logging levels
const LogLevel = {
    DEBUG: 'DEBUG',
    INFO: 'INFO',
    WARN: 'WARN',
    ERROR: 'ERROR'
};

class LoggingService {
    isDebugEnabled: boolean;

    constructor() {
        this.isDebugEnabled = import.meta.env.DEV;
    }

    formatMessage(level: string, message: string, data: any = null) {
        const timestamp = new Date().toISOString();
        return {
            timestamp,
            level,
            message,
            data
        };
    }

    debug(message, data = null) {
        if (this.isDebugEnabled) {
            console.debug(this.formatMessage(LogLevel.DEBUG, message, data));
        }
    }

    info(message, data = null) {
        console.info(this.formatMessage(LogLevel.INFO, message, data));
    }

    warn(message, data = null) {
        console.warn(this.formatMessage(LogLevel.WARN, message, data));
    }

    error(message, error = null) {
        console.error(this.formatMessage(LogLevel.ERROR, message, {
            error: error?.message || error,
            stack: error?.stack
        }));
    }

    // Network request logging
    logRequest(config) {
        this.debug('API Request', {
            method: config.method?.toUpperCase(),
            url: config.url,
            headers: config.headers,
            data: config.data
        });
    }

    logResponse(response) {
        this.debug('API Response', {
            status: response.status,
            statusText: response.statusText,
            headers: response.headers,
            data: response.data
        });
    }

    logError(error) {
        this.error('API Error', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
            config: {
                method: error.config?.method?.toUpperCase(),
                url: error.config?.url
            }
        });
    }
}

export const logger = new LoggingService(); 